import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  proposition: null,
  isVisible: false,
  // Consumables A/B: when the primary ad's re-boost window closes (ms);
  // null until read, and when there is no window.
  reboostClosesAt: null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
